<template>
    <div class="iframe_container">
        <iframe frameborder=0 width="100%" height="1000"
            src="https://analytics.zoho.com/open-view/1403135000006239259/d46c3eb5ccd2625b9d285ba1809e5044"></iframe>
    </div>
</template>

<script>
export default {
    
}
</script>

<style scoped>
 .iframe_container {
    margin-left: 10 rem;
 }
</style>